import React, { ReactElement } from 'react'
import { Grid, Image, Wrapper, H, P } from '@farewill/ui'
import styled from 'styled-components'

const StyledWrapper = styled(Wrapper)`
  height: 200px;
`

const StyledImage = styled(Image)`
  height: 100%;
`

const SliceFeatures = (): ReactElement => {
  const CardsData = [
    {
      id: 'listen-to',
      title: 'Do it your way',
      image: '/illustrations/why-people-are-choosing',
      content: (
        <P>
          Create the send-off you want, when you’re ready. With more time to
          grieve, plan, and get everyone together.
        </P>
      ),
    },
    {
      id: 'do-admin',
      title: 'It’s simpler',
      image: '/illustrations/urn-and-hands',
      content: (
        <P>
          Cut the extra fuss and burden of a traditional funeral. Things like a
          hearse, an organist, or arranging parking.
        </P>
      ),
    },
    {
      id: 'make-sure',
      title: 'It’s cheaper',
      image: '/illustrations/fair-on-price',
      content: (
        <P>
          We’re 4x cheaper than the average traditional UK funeral, saving you
          thousands.
        </P>
      ),
    },
  ]

  return (
    <Grid>
      {CardsData.map((data) => (
        <Grid.Item
          key={data.id}
          spanFromM={10}
          startColumnFromM={2}
          spanFromL={4}
          startColumnFromL="auto"
        >
          <Wrapper paddingFromM={['M', 0]} paddingFromL={[0]}>
            <StyledWrapper margin={[0, 0, 'M']} centered>
              <StyledImage path={data.image} width={200} />
            </StyledWrapper>

            <H size="S">{data.title}</H>
            {data.content}
          </Wrapper>
        </Grid.Item>
      ))}
    </Grid>
  )
}

export default SliceFeatures
